export default __webpack_public_path__ + "static/media/Perrie_9781408339510.6025d171.jpg";